// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7086":"d70ca405","7273":"9388a0db","7667":"d70ca405"}[chunkId] + ".chunk.css";
};